export const STORAGE_KEYS = {
  TASKS: 'task_dashboard_tasks',
  SETTINGS: 'task_dashboard_settings'
}

export const FILTER_STATUS = {
  ALL: 'all',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  OVERDUE: 'overdue'
}

export const SORT_ORDER = {
  DUE_DATE: 'dueDate',
  PRIORITY: 'priority',
  CUSTOM: 'custom'
}

export const PRIORITY_LABELS = {
  high: '高',
  medium: '中',
  low: '低'
}
